<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-user-tag"></i>&nbsp;<ng-container i18n>New Attribute</ng-container></h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-sm-12">
      <p i18n>Please enter new attribute name</p>
    </div>
    <div class="col-sm-12">
      <form [formGroup]="form">
        <mat-form-field2 class="mat-block">
          <input type="text" formControlName="value" required matInput placeholder="Attribute Name" i18n-placeholder />
          <mat-error *ngIf="form.get('value').touched && form.get('value').hasError('required')">
            <ng-container i18n>Value is required</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('value').touched && form.get('value').hasError('allSpaces')">
            <ng-container i18n>Value must not be empty</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('value').touched && form.get('value').hasError('pattern')">
            <ng-container i18n>Value can only contain letters and spaces</ng-container>
          </mat-error>
        </mat-form-field2>
      </form>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="save(form)" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
